

















































































import { isEmail } from 'validator';

export default {
    name: 'CoLink',
    props: {
        to: {
            type: String,
            default: '/',
        },

        styles: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        newTab: {
            type: Boolean,
            default: false,
        },
        isExternalLink: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            let classList = this.styles.split(' ');
            if (this.disabled) {
                classList.push('disabled');
            }
            return classList.join(' ');
        },
        href() {
            if (!this.to) return '';
            const containHTTPS = this.to.includes('https://') || this.to.includes('http://');

            if (isEmail(this.to)) {
                return `mailto:${this.to}`;
            }

            if (this.isExternalLink && !containHTTPS) {
                return `https://${this.to}`;
            }

            return this.to;
        },
    },

    data() {
        return {};
    },
    methods: {
        click(event) {
            if (this.disabled) return;
            this.$emit('click', event);
        },
    },
};
